import { useMutation } from '@tanstack/react-query'
import { invalidateRelevantActionQueries } from '@/lib/api/med-requests/action'
import http from '@/lib/http'
import { isUserTrialPrescriber } from '@/lib/permissions'
import { useUtilityStore } from '@/lib/stores/utils'
import { queryClient } from '@/services/queryClient'
import type { MedRequest } from '@/types/data'

export default function useSendFanConsultation() {
  const isTrialPrescriber = isUserTrialPrescriber()

  return useMutation({
    mutationFn: async ({ medRequest, questionnaireHash }: { medRequest: MedRequest; questionnaireHash: string }) => {
      if (isTrialPrescriber) {
        const { actionedMedicationRequestIds, setActionedMedicationRequestIds } = useUtilityStore.getState()
        setActionedMedicationRequestIds(Array.from(new Set([...actionedMedicationRequestIds, medRequest.id])))
        return
      }

      await http.post(`/prescriber/med-requests/${medRequest.id}/fan-request`, { questionnaireHash })
    },
    onSuccess(_, { medRequest }) {
      queryClient.setQueriesData(
        { queryKey: ['medRequestFiltering'] },
        (old: { data: MedRequest[]; total: number }) => ({
          ...old,
          data: old.data.filter(request => request.id !== medRequest.id)
        })
      )
      invalidateRelevantActionQueries(medRequest.patient.id, medRequest.id)
      queryClient.invalidateQueries({ queryKey: ['totalMedicationRequests'] })
    }
  })
}
